<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="ded"></a><a id="page_vii">There can be no other dedication: To the men and women of the U.S. military, for all the reasons we know and all the reasons we will never know.</a></p><a id="page_vii">
</a><p class="ded1"><a id="page_vii">And to Kayla, Blake, Lane, and Hailey. You bless my life with untold riches.</a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?7b80d458